import { jsx as n, jsxs as s, Fragment as a } from "react/jsx-runtime";
import { I as t } from "../../../../icon-B72I4fRl.js";
const k = "_description_14nb5_67", u = "_name_14nb5_77", e = {
  "checkbox-contained": "_checkbox-contained_14nb5_29",
  "has-description": "_has-description_14nb5_63",
  description: k,
  name: u,
  "no-description": "_no-description_14nb5_85",
  "no-icon": "_no-icon_14nb5_99",
  "has-icon": "_has-icon_14nb5_102"
}, v = ({
  type: r = "checkbox",
  label: o,
  title: d,
  name: _,
  value: h = 1,
  checked: l,
  required: m = !1,
  onChange: p,
  icon: c,
  inputNumber: b = 0,
  description: i,
  id: x
}) => /* @__PURE__ */ n("div", { className: e["checkbox-contained"], children: /* @__PURE__ */ s(
  "label",
  {
    className: `${i ? e["has-description"] : e["no-description"]} ${c ? e["has-icon"] : e["no-icon"]}`,
    title: d,
    id: x,
    children: [
      /* @__PURE__ */ n(
        "input",
        {
          type: r,
          name: _,
          value: h,
          checked: l,
          onChange: p,
          required: m,
          "data-input-number": b
        }
      ),
      i ? /* @__PURE__ */ s(a, { children: [
        /* @__PURE__ */ s("div", { className: e.name, children: [
          c && /* @__PURE__ */ n(t, { name: c, size: "2xl" }),
          /* @__PURE__ */ n("span", { children: o })
        ] }),
        /* @__PURE__ */ n("div", { className: e.description, title: i, children: i })
      ] }) : /* @__PURE__ */ s(a, { children: [
        c && /* @__PURE__ */ n(t, { name: c, size: "2xl" }),
        /* @__PURE__ */ n("span", { children: o })
      ] })
    ]
  }
) });
export {
  v as CheckboxContained
};
